import { InfoWindow } from "@react-google-maps/api";
import React from "react";
import ReactGA from "react-ga";
import { scroller } from "react-scroll";

const MarkerInfoWindow = ({
  marker,
  restaurant,
  onClose
}: {
  marker: any;
  restaurant: RestaurantFromAPI;
  onClose: () => void;
}) => {
  const scrollToRestaurant = () => {
    const { key } = restaurant;
    scroller.scrollTo(key, {
      duration: 500,
      smooth: true,
      offset: -80
    });
    ReactGA.event({
      category: "Map",
      action: "More Info",
      label: key
    });
  };
  return (
    <InfoWindow anchor={marker} onCloseClick={onClose}>
      <div style={{ backgroundColor: "white" }}>
        <h1 style={{ fontSize: "3.5vh" }}>{restaurant.name}</h1>
        <h2 style={{ fontSize: "2vh" }}>{restaurant.discountString}</h2>
        <p className="text-muted" style={{ fontSize: "1.5vh" }}>
          {restaurant.longAddress}
        </p>
        <button
          onClick={scrollToRestaurant}
          className="btn btn-primary ml-2"
          style={{
            float: "right",
            display: "inline-block",
            fontSize: "1.5vh"
          }}
        >
          More Info
        </button>
        <ReactGA.OutboundLink
          eventLabel={"Direction to " + restaurant.key}
          to={
            "https://www.google.com/maps/dir/?api=1&destination=" +
            encodeURI(restaurant.name + " " + restaurant.longAddress)
          }
        >
          <button
            className="btn btn-primary"
            style={{
              float: "right",
              display: "inline-block",
              fontSize: "1.5vh"
            }}
            onClick={() =>
              ReactGA.event({
                category: "Map",
                action: "Get Directions",
                label: restaurant.key
              })
            }
          >
            Directions
          </button>
        </ReactGA.OutboundLink>
      </div>
    </InfoWindow>
  );
};

export default MarkerInfoWindow;
